import type { AudienceSegment } from "./unified-messaging.types";

/** The most groups one audience-count request may carry. */
export const AUDIENCE_COUNT_MAX_GROUPS = 50;
export const AUDIENCE_COUNT_MAX_SEGMENTS = 2 * AUDIENCE_COUNT_MAX_GROUPS;

export interface ComedianAudienceCountRequest {
  comedianId: string;
  /** Each group is one part of the audience (a venue, a list); the total counts every person across all groups once. */
  groups: { key: string; segments: AudienceSegment[] }[];
  onlySubscribers?: boolean;
}

export interface ComedianAudienceCountResponse {
  /** People reached across all groups, counted once. */
  total: number;
  emails: number;
  texts: number;
  /** People per group key after filtering; someone in two groups counts in both. */
  groupCounts: Record<string, number>;
  /** The Punchup-subscriber share of `groupCounts`. */
  groupSubscriberCounts: Record<string, number>;
  /** People who are in more than one group (and are still sent to once). */
  multiGroupCount: number;
}
